import React from 'react';
import { IInstructorDetails, IInstructors, ISocialLinks } from '@/interfaces/courseDescription';
import { s3Url } from '@/utils/common/env.constants';
import CardDetailsView from './CardDetailsView';
// import CourseDescriptionContext from '../../../../context/CourseDescriptionContext';
// import CategoryPageContext from '../../../../context/CategoryPageContext';

type Props = {
  mentor: IInstructors;
  isLinkedInButtonEnabled: boolean;
  learnersPlacedToBeShown: boolean;
  industryExpToBeShown: boolean;
  isSocialIconEnabled: boolean;
};

const MentorCard = ({
  mentor,
  isLinkedInButtonEnabled,
  learnersPlacedToBeShown,
  industryExpToBeShown,
  isSocialIconEnabled,
}: Props) => {
  const { description, social, name, img, instructorDetails } = mentor;
  // Social links may arrive nested under `social` or as top-level keys on the
  // mentor object, so resolve each platform from whichever shape is present.
  const mentorSocial = mentor as IInstructors & ISocialLinks;
  const socialLinks: ISocialLinks = {
    linkedin: social?.linkedin ?? mentorSocial.linkedin,
    youtube: social?.youtube ?? mentorSocial.youtube,
    facebook: social?.facebook ?? mentorSocial.facebook,
    instagram: social?.instagram ?? mentorSocial.instagram,
    twitter: social?.twitter ?? mentorSocial.twitter,
  };
  // const { courseDetails } = useContext(CourseDescriptionContext);
  // const { categoryDetails } = useContext(CategoryPageContext);

  //   const sendDataLayerEvent = (videoURL: string | undefined, section: string) => {
  //     const dataLayerObj = {
  //       event: 'video_click',
  //       section_name: section,
  //       course_id: courseDetails?._id || categoryDetails?._id || '',
  //       video_url: videoURL,
  //     };
  //     dataLayer(dataLayerObj);
  //   };
  const handleImageLink = () => {
    if (typeof img === 'string') return img;
    if (img?.source === 'url' || img?.link?.includes('https')) return img?.link;
    return `${s3Url}/user/profile_pictures/${img?.link}`;
  };
  return (
    <div className="relative !w-[328px] bg-white rounded-b-[8px] rounded-t-[8px] h-auto shadow-light shrink-0 flex flex-col">
      {/* <VideoModal
        // title={name || ''}
        title=""
        modalOpen={modelOpen}
        setModelOpen={setModelOpen}
        videoUrl=""
        // videoUrl={video?.link || ''}
        section="mentors"
      /> */}
      <div className="absolute w-6 h-6 top-2 left-3">
        <img
          src="/images/accountImage/leadform/Dots.svg"
          alt="arrow-bg"
          className="w-full h-full object-contain"
        />
      </div>
      <img
        src="/images/homePageRevamp/SkillsEmbossMentor.svg"
        alt="Backgraound img"
        className="absolute rounded-t-[8px] left-4"
      />
      <div
        // className={`relative ${video && 'cursor-pointer'}`}
        // onClick={() => {
        //   if (video && Object.keys(video).length) {
        //     setModelOpen(true);
        //     sendDataLayerEvent(video.link, 'mentors');
        //   }
        // }}
        aria-hidden="true"
        className="rounded-t-[8px] border-b-none"
        style={{
          background:
            'radial-gradient(47.44% 86.27% at 50% 50%, rgba(255, 241, 228, 0.85) 0%, rgba(255, 178, 163, 0.85) 100%), #FFF',
        }}
      >
        <picture className="flex items-end justify-end !h-[204px]">
          <img
            src={handleImageLink()}
            alt="mentor-img"
            // alt={name || ''}
            // width={411}
            // height={204}
            className="relative !w-[202px] !h-[180px] rounded-t-[8px] mr-4"
          />
        </picture>
      </div>

      <CardDetailsView
        name={name}
        instructorDetails={instructorDetails as IInstructorDetails}
        description={description as string}
        social={socialLinks}
        isLinkedInButtonEnabled={isLinkedInButtonEnabled}
        learnersPlacedToBeShown={learnersPlacedToBeShown}
        industryExpToBeShown={industryExpToBeShown}
        isSocialIconEnabled={isSocialIconEnabled}
      />
    </div>
  );
};

export default MentorCard;
